import React from 'react';
import {
  Modal, Box, Typography, IconButton, alpha, useTheme
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

interface DemoModalProps {
  open: boolean;
  onClose: () => void;
}

const DemoModal: React.FC<DemoModalProps> = ({ open, onClose }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="demo-modal-title"
      aria-describedby="demo-modal-description"
      sx={{
        backdropFilter: 'blur(8px)',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '95%', sm: '90%', md: '80%' },
          maxWidth: 900,
          bgcolor: 'background.paper',
          borderRadius: 4,
          boxShadow: 24,
          overflow: 'hidden',
          border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
        }}
      >
        <Box
          sx={{
            background: `linear-gradient(135deg, 
              ${alpha(theme.palette.primary.main, 0.1)} 0%, 
              ${alpha(theme.palette.secondary.main, 0.1)} 100%)`,
            p: 3,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
          }}
        >
          <Typography
            variant="h5"
            id="demo-modal-title"
            sx={{
              fontWeight: 'bold',
              background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}
          >
            {t('home.demoModal.title')}
          </Typography>
          <IconButton
            onClick={onClose}
            sx={{
              color: theme.palette.grey[600],
              '&:hover': {
                color: theme.palette.primary.main,
                transform: 'scale(1.1)',
              },
              transition: 'all 0.2s ease',
            }}
          >
            <Close />
          </IconButton>
        </Box>
        <Box sx={{ p: 3 }}>
          <Box
            sx={{
              position: 'relative',
              width: '100%',
              paddingTop: '56.25%', // 16:9 aspect ratio
              borderRadius: 2,
              overflow: 'hidden',
              boxShadow: `0 10px 30px ${alpha(theme.palette.common.black, 0.3)}`,
            }}
          >
            <iframe
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 'none',
              }}
              src="https://www.youtube.com/embed/dQw4w9WgXcQ?rel=0&modestbranding=1"
              title="Astrologys.ai Demo"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </Box>
          <Typography
            variant="body2"
            sx={{
              mt: 2,
              textAlign: 'center',
              color: theme.palette.text.secondary,
              fontStyle: 'italic'
            }}
          >
            {t('home.demoModal.description')}
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
};

export default DemoModal; 